import { SCREENS } from "utils/constants";
import Create from "./Create";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.RULES.CREATE.path,
    exact: true,
    element: <Create />,
  },
];

export default routes;
